import { Button, Card, Space } from 'antd';
import { BarChartOutlined, CalendarOutlined, EditOutlined, SettingOutlined } from '@ant-design/icons';
import React from 'react';

import { Link } from 'react-router-dom';
import DashboardStatistics from '../DashboardStatistics';

import './dashboard-card.less';

const DashboardCard = ({
  title,
  period,
  actions = [],
  extra = [],
  resultsUrl,
  manageUrl,
  manageLabel = 'Manage',
  settingsUrl,
  settingsLabel = 'Settings',
  name,
  statistics,
  isEmpty,
  emptyAction,
  children,
  loading,
  module,
  disabled,
}) => {
  const cardActions = [];

  if (resultsUrl) {
    cardActions.push(
      <Link key="results" to={resultsUrl}>
        <Button type="link" icon={<BarChartOutlined />} className={name && `results-${name}`}>Browse results</Button>
      </Link>,
    );
  }

  if (isEmpty && emptyAction) {
    cardActions.push(emptyAction);
  }

  if (manageUrl) {
    cardActions.push(
      <Link key="manage" to={manageUrl}>
        <Button type="link" icon={<EditOutlined />} className={name && `manage-${name}`}>{manageLabel}</Button>
      </Link>,
    );
  }

  if (settingsUrl) {
    cardActions.push(
      <Link key="settings" to={settingsUrl}>
        <Button type="link" icon={<SettingOutlined />} className={name && `settings-${name}`}>{settingsLabel}</Button>
      </Link>,
    );
  }

  if (period) {
    extra.push(
      <Space key="period">
        <CalendarOutlined />
        {period}
      </Space>,
    );
  }

  cardActions.push(...actions);

  return (
    <Card
      className={`dashboard-card ${module && `module-${module.toLowerCase().replace('_', '-')}`} ${disabled ? 'disabled' : ''}`}
      title={title}
      extra={extra}
      actions={cardActions}
      loading={loading}
    >
      {statistics?.length > 0 && (
        <DashboardStatistics statistics={statistics} />
      )}

      {children}
    </Card>
  );
};

export default DashboardCard;
